export default __webpack_public_path__ + "assets/images/1527c4d49450ca47c3ea884f4d0ac7f7.png";